jQuery(document).ready(function($) {
	  // Akkordeon bei den Produkten
		$('.accordeon-item-title').click(function (event) {
			event.preventDefault();
			_this = this;
			$target = $(_this).next();
	
			// Bestimme den Zustand vor dem Toggle
			var wasOpen = $(_this).hasClass('is-open');
	
			// Aktionen ausführen
			$target.slideToggle();
			$(_this).toggleClass('is-open');
	
			// Sende nur ein Event, wenn das Akkordeon geöffnet wird
			if (!wasOpen) {
				// Hole den Titel aus dem Label-Element
				var title = $(_this).find('.item-title-label').text().trim();
				
				// Rufe die Data Layer Push Funktion auf
				pushAccordionEvent(title, 'open');
			}
	
	
		 /*  if ($(_this).hasClass('is-open')) {
				accordeonScrollTo($(_this));
			} */
		});
	
		/* var accordeonScrollTo = function (target) {
			var t = target;
			var $page = $('html, body');
	
			$page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
				$page.stop();
			});
	
			$page.animate({
				scrollTop: t.offset().top - 10,
			}, 'slow', function () {
					$page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
				});
	
			return false;
		}; */
	
		function pushAccordionEvent(title, action) {
			// Stellen sicher, dass der dataLayer existiert
			window.dataLayer = window.dataLayer || [];
			
			// Senden des Events an den Data Layer
			window.dataLayer.push({
				'event': 'accordion_interaction',
				'accordion_title': title,
				'accordion_action': action
			});
			
		}
});